import { hasPermission } from '@scp/lib-common/auth'

// TODO: cache the formated permissions

/**
 * Uses hasPermission to determine if user has permission according to the current profile
 * @param {Object} profile
 * @param {string} scope
 * @return {number} returns true if no scope ELSE hasPermission returns
 */
function checkScope (profile: any, scope: string) {
  if (!scope) {
    return true
  } else {
    return hasPermission(profile.session.scope, scope)
  }
}

export { checkScope }
